import { useEffect, useLayoutEffect, useRef } from 'react';
import type { RefObject } from 'react';
import { createInstance } from '../../hooks';
import type { CustomMindmapInstance } from '../../hooks';
import { useStoreApi } from '../../store';

/** Registers the gesture surface for screen → flow conversion and calls `onInit(instance)` once after mount (v11). */
export const useCanvasInit = (
  rendererRef: RefObject<HTMLElement>,
  onInit: ((instance: CustomMindmapInstance) => void) | undefined,
): void => {
  const store = useStoreApi();
  const onInitRef = useRef(onInit);
  useLayoutEffect(() => {
    onInitRef.current = onInit;
  }, [onInit]);
  useLayoutEffect(() => {
    store.getState().setDomNode(rendererRef.current);
    return () => store.getState().setDomNode(null);
  }, [store, rendererRef]);
  useEffect(() => {
    onInitRef.current?.(createInstance(store));
  }, [store]);
};
